import PlantsList from './PlantsList';
import PlantsEdit from './PlantsEdit';

export default {
    list: PlantsList,
    edit: PlantsEdit,
}